import { useEffect, useState, useContext } from "react";

import { AppContext } from '../../context.js';

function SessionTimer(props) {

  const context = useContext(AppContext);
  
  const [expireAt, setExpireAt] = useState(new Date(context.expireAt));
  const [soon, setSoon] = useState(false); 
  const [expired, setExpired] = useState(false);
  const [left, setLeft] = useState(0);

  // Check every 2 seconds if the session is expiring soon or has expired
  useEffect(() => {
    const interval = setInterval(() => {
        if (expireAt <= Date.now()) {
            setSoon(false);
            setExpired(true);
            setLeft(0);
        } else if (expireAt - Date.now() < 15 * 60 * 1000) {
            setSoon(true);
            setExpired(false);
            setLeft(Math.max(0, Math.ceil((expireAt - Date.now()) / 60 / 1000)));
        }
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div 
      style={{
        position: 'fixed', 
        left: '20px', 
        bottom: '20px', 
        display: expired || soon ? 'block' : 'none',
        zIndex: 9999,
        maxHeight: '400px',
        overflowY: 'auto'
      }}
    >
      <div className="card shadowmore mb-2" style={{width: 300}}>
        <div className="card-header sm">
          <div className="d-flex justify-content-between align-items-center">
            <span className="typo-strong-175 text-danger">{expired ? "Session expired" : soon ? "Session expires soon" : ""}</span>
            {/* <div className="item" onClick={() => {}}><Close height={16} width={16} background={'none'} fill={'grey'} /></div> */}
          </div>
        </div>
        <div className="card-content sm">
          <div className="typo-normal-150">
            {expired ? (
                <span>Your session has expired. Please log in again to continue working.</span>
            ) : left >= 0 ? (
                <span>Your session will expire in {left} {left === 1 ? "minute" : "minutes"}. Please save your work.</span>
            ) : (
                <span>Session timeout. Progress could be lost.</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SessionTimer;